import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useDayClosingVideoConsultationPostAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();

  const execute = useCallback(
    async (data: { booking_id: string; exception_reason?: string }) => {
      dispatch(
        setLoading({
          key: "isCollectAmountDataInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .post(`${DAY_CLOSING_APIS?.VIDEO_CONSULTATION?.baseURL}`, data, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              toastNotification(res.data.message);
              dispatch(
                setLoading({
                  key: "isCollectAmountDataInProgress",
                  status: false,
                }),
              );
              return { status: true };
            }
            dispatch(
              setLoading({
                key: "isCollectAmountDataInProgress",
                status: false,
              }),
            );
            return { status: false };
          })
          .catch((e: AxiosError) => {
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            captureError(e);
            dispatch(
              setLoading({
                key: "isCollectAmountDataInProgress",
                status: false,
              }),
            );
            return { status: false };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, dispatch, sendCurl, toastNotification],
  );

  return { execute };
};
